<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-geo-data">
      <i class="iconoir-pin-alt grid-field-geo-data__icon"></i>
      <span class="grid-field-geo-data__text">
        <SearchHighlightedText :text="displayValue" :search-term="searchTerm" />
      </span>
    </div>
  </div>
</template>

<script>
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldGeoData',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: Object,
      default: null,
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    displayValue() {
      if (!this.value || this.value.lat == null || this.value.lng == null) {
        return this.$t('gridViewFieldGeoData.noLocation')
      }
      return `${this.value.lat}, ${this.value.lng}`
    },
  },
}
</script>
